import { Typography } from "@circle-react-shared/uikit/Typography";
import { Row as RowSkeleton } from "@circle-react-uikit/SkeletonLoader/components/Row";
import { formatPaywallCurrencyAmount } from "@circle-react/helpers/paywalls/currencies";

import { usePricePreviewContext } from "../../../PricePreviewProvider";

export const Value = () => {
  const { previewMutation } = usePricePreviewContext();
  const preview = previewMutation.data;

  if (!preview || previewMutation.isPending) {
    return (
      <div className="flex flex-row items-center gap-x-1.5">
        <RowSkeleton lg />
      </div>
    );
  }

  const shouldShowOriginalValue =
    !preview?.trial_period?.free && preview.first_payment?.discount < 0;

  return (
    <div className="flex flex-row gap-x-1.5">
      {shouldShowOriginalValue && (
        <Typography.LabelMd weight="semibold" color="text-disabled">
          <span className="line-through">
            {formatPaywallCurrencyAmount(
              preview.currency,
              preview.first_payment.price_amount,
              { includeCurrencyCode: false },
            )}
          </span>
        </Typography.LabelMd>
      )}
      <Typography.LabelMd weight="semibold">
        {formatPaywallCurrencyAmount(preview.currency, preview.amount_due_now)}
      </Typography.LabelMd>
    </div>
  );
};
